import commonService from "@/commonService";
import store from "@/store/index";
import { dateFormat } from "@/utils/dataFormatUtil";

const intervalTime = 60 * 1000;
// 用户请求是否有新的订单
async function reqClueData() {
  if (!store.state.orgInfo.id) return false;
  if (!store.state.isOrgAuth) return false;
  const result = await commonService.saasNewLeadTip({
    // 机构id
    orgId: store.state.orgInfo.id,
    // 社区id
    comtyId: "",
    createTimeBegin: dateFormat(new Date(new Date().getTime() - intervalTime), "yyyy-MM-dd hh:mm:ss"),
    createTimeEnd: dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
  });
  const { data } = result;
  const { hasNewLead } = data;
  console.log(data, hasNewLead, "...");
  return hasNewLead;
}
// 语音播报
// 用于播报线索通知
function createAudio() {
  console.log("创建audio");

  const audio = new Audio("https://wenwo-static-test.oss-cn-beijing.aliyuncs.com/common/publicRes/patient/video/video-sass.mp4");
  audio.addEventListener("canplaythrough", () => {
    console.log("loaded");
    try {
      setInterval(async () => {
        if (await reqClueData()) {
          console.log("play...");
          audio.play();
        }
      }, intervalTime);
    } catch (error) {
      console.error(error, "...");
    }
  });
}

createAudio();
